<div
  *ngFor="let loader of elementArray(); let i = index"
  [appLoadingTextSkeleton]="i % 2 ? false : true"
  class="list-skeleton"
></div>
